import type { ChildAppConfig } from '@shared/app-config'
import type { ProxyConfig } from '@shared/wippy-package/wippy-package'
import { buildSchemaUrl } from '@shared/app-config/migration'

const STORAGE_KEY_CONFIG = '@wippy-dev/config'
const STORAGE_KEY_PROXY_CONFIG = '@wippy-dev/proxy-config'
const STORAGE_KEY_AUTO_ACCEPT = '@wippy-dev/auto-accept'

export function getStoredConfig(): ChildAppConfig | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_CONFIG)
    if (!raw)
      return null
    return JSON.parse(raw) as ChildAppConfig
  }
  catch {
    return null
  }
}

export function saveConfig(config: ChildAppConfig): void {
  localStorage.setItem(STORAGE_KEY_CONFIG, JSON.stringify(config))
}

export function getStoredProxyConfig(): Partial<ProxyConfig> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PROXY_CONFIG)
    if (!raw)
      return null
    return JSON.parse(raw) as Partial<ProxyConfig>
  }
  catch {
    return null
  }
}

export function saveProxyConfig(config: Partial<ProxyConfig>): void {
  localStorage.setItem(STORAGE_KEY_PROXY_CONFIG, JSON.stringify(config))
}

export function isAutoAccept(): boolean {
  return localStorage.getItem(STORAGE_KEY_AUTO_ACCEPT) === 'true'
}

export function setAutoAccept(value: boolean): void {
  localStorage.setItem(STORAGE_KEY_AUTO_ACCEPT, String(value))
}

export function clearAll(): void {
  localStorage.removeItem(STORAGE_KEY_CONFIG)
  localStorage.removeItem(STORAGE_KEY_PROXY_CONFIG)
  localStorage.removeItem(STORAGE_KEY_AUTO_ACCEPT)
}

export function getDefaultConfig(): ChildAppConfig {
  return {
    $schema: buildSchemaUrl(),
    auth: {
      token: 'dev-token',
      expiresAt: '',
    },
    env: {
      APP_API_URL: `${location.origin}/api`,
      APP_AUTH_API_URL: `${location.origin}/api`,
      APP_WEBSOCKET_URL: `${location.origin.replace(/^http/, 'ws')}/ws`,
    },
    theming: { global: {} },
    context: {
      resourceId: '',
      resourceType: 'page',
    },
  }
}

export function getDefaultProxyConfig(): ProxyConfig {
  return {
    enabled: true,
    injections: {
      css: {
        themeConfig: false,
        iframe: false,
        primevue: false,
        markdown: false,
        customCss: true,
        customVariables: true,
      },
      tailwindConfig: true,
      resizeObserver: false,
      preventLinkClicks: false,
      iconifyIcons: true,
      refreshWhenVisible: false,
      historyPolyfill: true,
      errorCapture: true,
    },
  }
}
